var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcAddPhotoEditProfile(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icAddPhotoEditProfile") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.6,2.13162821e-14 C4.296,2.13162821e-14 -9.23705556e-14,4.296 -9.23705556e-14,9.6 C-9.23705556e-14,14.904 4.296,19.2 9.6,19.2 C14.904,19.2 19.2,14.904 19.2,9.6 C19.2,4.296 14.904,2.13162821e-14 9.6,2.13162821e-14 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5983276,9.60001972 L13.5932363,6.60510747 C13.8689212,6.3294222 13.8689212,5.88244922 13.5932363,5.60680339 C13.3175513,5.33111812 12.8706183,5.33111812 12.5949334,5.60680339 L9.59998521,8.60175508 L6.60503704,5.60676395 C6.32935209,5.33107868 5.88241907,5.33107868 5.60673413,5.60676395 C5.33108862,5.88244922 5.33108862,6.3294222 5.60673413,6.60506803 L8.6016823,9.59998028 L5.60673413,12.594932 C5.33108862,12.8706172 5.33108862,13.3175902 5.60673413,13.593236 C5.88241907,13.8689213 6.32935209,13.8689213 6.60503704,13.593236 L9.59998521,10.5982844 L12.5949334,13.593236 C12.8705789,13.8689213 13.3175513,13.8689213 13.5932363,13.593236 C13.8689212,13.3175508 13.8689212,12.8706172 13.5932363,12.594932 L10.5983276,9.60001972 Z",
    id: "path-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Edit-Profile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icAddPhotoEditProfile",
    transform: "translate(0.400000, 0.400000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FFFFFF",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Shape",
    fill: "#7BCB45",
    fillRule: "nonzero",
    transform: "translate(9.600000, 9.600000) rotate(-44.000000) translate(-9.600000, -9.600000) ",
    xlinkHref: "#path-3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAddPhotoEditProfile);
export default __webpack_public_path__ + "static/media/icAddPhotoEditProfile.af1961495144ce2f6a03d1ccba22ee75.svg";
export { ForwardRef as ReactComponent };